import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  Grid,
  Typography
} from "@mui/material";
import Error from "@mui/icons-material/Error";
import Close from "@mui/icons-material/Close";

const AlertModal = (props) => {
  const { isOpen, toggle, header, body } = props;

  return (
    <Dialog fullWidth maxWidth={"xs"} open={isOpen} onClose={toggle}>
      <DialogTitle color="white" sx={{ padding: 0, bgcolor: "error.main" }}>
        <Grid container>
          <Grid item xs={3} />
          <Grid item xs={6} sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-block",
                paddingTop: "10px",
                paddingBottom: "10px"
              }}
            >
              <Error
                fontSize="small"
                sx={{ display: "inline-block", verticalAlign: "middle" }}
              />{" "}
              <Typography
                sx={{
                  display: "inline-block",
                  fontWeight: 500,
                  verticalAlign: "center"
                }}
              >
                {header.toUpperCase()}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Button
              onClick={toggle}
              color="inherit"
              sx={{
                float: "right",
                minWidth: 0,
                width: "40px",
                height: "30px",
                ":hover": {
                  bgcolor: "error.dark"
                }
              }}
            >
              {" "}
              <Close fontSize="small" />
            </Button>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default AlertModal;
